import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { countries } from '../../../shared/Model/countries-store';
import { MembershipService } from '../memberships/Services/Membership.service';
import { dropdown } from '../../../shared/Model/dropdoen.model';
import { ToasterComponent } from "../../../shared/Componet/toaster/toaster.component";

@Component({
  selector: 'app-apply-for-membership',
  imports: [TranslateModule, CommonModule, ReactiveFormsModule, ToasterComponent],
  templateUrl: './apply-for-membership.component.html',
  styleUrl: './apply-for-membership.component.css'
})
export class ApplyForMembershipComponent {

  showMembershipModal: boolean = false;
  errorMessage: string | null = null;
  MembershipForm!: FormGroup;
  AttachmentsForm!: FormGroup;
  CouponForm!: FormGroup;
  showToast = false;
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';
  id: number | null = null;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  private subs = new Subscription();   // container for all subscriptions
  roles: any;
  public countries: any = countries;
  isUserCreatedBefore: boolean = false;
  membershipId: number = 0;
  membershipStatus: string = ''
  // finalPrice: number = 0;
  // logs: any[] = [];
  // price: number = 0;
  // previewUrls: (string | ArrayBuffer)[] = [];
  attachments: File[] = [];
  isExpired: boolean = false
  isMember: boolean = localStorage.getItem("isMember") === 'true';
  @Input() membershipDataForUser: any;
  @Output() membershipStatusChanged = new EventEmitter<string>();
  @Output() getMembershipByUserId = new EventEmitter<void>();


  private fb = inject(FormBuilder);
  private cdr = inject(ChangeDetectorRef)
  private translate = inject(TranslateService)

  private MembershipService = inject(MembershipService)

  selectedNationalIdFrontPath!: File | null;
  previewUrl1: string | ArrayBuffer | null = null;

  selectedNationalIdBackPath!: File | null;
  previewUrl2: string | ArrayBuffer | null = null;

  selectedPassportImagePath!: File | null;
  previewUrl3: string | ArrayBuffer | null = null;

  selectedSupportedDocuments: File[] = [];
  previewUrls4: (string | ArrayBuffer)[] | any = [];

  selectedCountry: any = "";
  traningLevels: dropdown[] = [] as dropdown[];
  selectedTraningLevel: dropdown = {} as dropdown;


  phoneLengthValidator(minLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.toString() || '';
      return value.length < minLength ? { minlength: true } : null;
    };
  }


  internationalPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      // لازم يبدأ بـ + ورقم دولة وبعده رقم
      const regex = /^\+\d{1,4}\d{10,14}$/;

      return regex.test(control.value)
        ? null
        : { invalidPhoneCode: true };
    };
  }

  ngOnInit(): void {
    this.MembershipForm = this.fb.group({
      fullArabicName: [''],
      fullEnglishName: [''],
      phoneNumber: ['', this.internationalPhoneValidator()],
      nationalIdNumber: [''],
      trainingLevelId: [0],
      placeOfWork: [''],
      nationality: [''],
    });

    this.AttachmentsForm = this.fb.group({
      note: ['']
    });

    this.CouponForm = this.fb.group({
      coupon: ['']   // إضافة الكوبون هنا
    });

    this.MembershipService.getTraningLevelId().subscribe((res) => {
      this.traningLevels = res.value;
      // this.selectedTraningLevel = this.traningLevels.find(x => +x.id === this.MembershipForm.get('trainingLevelId')?.value) ?? {} as dropdown;
    });

    //   this.id = +localStorage.getItem('userId')!;  // assuming userId is stored in localStorage

    //   this.MembershipService.getMembershipByUserId(this.id).subscribe({
    //     next: (res: any) => {
    //       this.isUserCreatedBefore = !!res.value.items.length;
    //       localStorage.setItem("isUserCreatedBefore", this.isUserCreatedBefore.toString())
    //       // console.log(" this.isUserCreatedBefore ", this.isUserCreatedBefore)
    //       // console.log("countries", this.countries)
    //       // console.log("this.selectedCountry", this.selectedCountry)
    //       this.isExpired = res.value.items.isExpired;

    //       if (this.isUserCreatedBefore) {
    //         this.membershipId = res.value.items[0].id;
    //         console.log("this.membershipId", this.membershipId)
    //         this.membershipStatus = res.value.items[0].membershipStatus
    //         this.membershipStatusChanged.emit(this.membershipStatus);
    //         this.MembershipForm.patchValue({
    //           id: res.value.items[0].id,
    //           fullArabicName: res.value.items[0].fullArabicName,
    //           fullEnglishName: res.value.items[0].fullEnglishName,
    //           phoneNumber: res.value.items[0].phoneNumber,
    //           nationalIdNumber: res.value.items[0].nationalIdNumber,
    //           trainingLevelId: res.value.items[0].trainigLevelId,
    //           placeOfWork: res.value.items[0].placeOfWork,
    //           nationality: res.value.items[0].nationality,
    //         });
    //         this.previewUrl1 = res.value.items[0].nationalIdFrontPath,
    //           this.previewUrl2 = res.value.items[0].nationalIdBackPath,
    //           this.previewUrl3 = res.value.items[0].passportImagePath
    //         // this.getMembershipById()
    //       }
    //     }
    //   })

  }

  // getMembershipById() {
  //   this.MembershipService.getMemberShipById(this.membershipId).subscribe({
  //     next: (res: any) => {
  //       this.finalPrice = res.value.finalPrice;
  //       this.price = res.value.price;
  //       this.logs = res.value.logs;
  //       this.previewUrls = [...this.previewUrls, ...res.value.attachments.map((att: any) => att.path)];
  //       // console.log("this.previewUrls", this.previewUrls)
  //     }
  //   })
  // }

  ngOnChanges() {

    if (this.membershipDataForUser) {
      this.membershipId = this.membershipDataForUser.id;
      // console.log("this.membershipId", this.membershipId)
      this.isUserCreatedBefore = !!this.membershipDataForUser;
      // console.log("this.isUserCreatedBefore", this.isUserCreatedBefore)
      // console.log("membershipDataForUser", this.membershipDataForUser)
      this.membershipStatus = this.membershipDataForUser.membershipStatus
      this.MembershipForm.patchValue({
        id: this.membershipDataForUser.id,
        fullArabicName: this.membershipDataForUser.fullArabicName,
        fullEnglishName: this.membershipDataForUser.fullEnglishName,
        phoneNumber: this.membershipDataForUser.phoneNumber,
        nationalIdNumber: this.membershipDataForUser.nationalIdNumber,
        trainingLevelId: this.membershipDataForUser.trainigLevelId,
        placeOfWork: this.membershipDataForUser.placeOfWork,
        nationality: this.membershipDataForUser.nationality,
      })
      this.previewUrl1 = this.membershipDataForUser.nationalIdFrontPath,
        this.previewUrl2 = this.membershipDataForUser.nationalIdBackPath,
        this.previewUrl3 = this.membershipDataForUser.passportImagePath,
        // this.previewUrls4 = this.membershipDataForUser.supportedDocuments,

        this.previewUrls4 = Array.isArray(this.membershipDataForUser.supportedDocuments)
          ? [...this.membershipDataForUser.supportedDocuments]
          : [];


      this.isExpired = this.membershipDataForUser.isExpired;

    }

    if (this.membershipStatus === 'Expired') {
      this.MembershipForm?.get('nationality')?.disable();
    } else {
      this.MembershipForm?.get('nationality')?.enable();
    }


    // console.log("this.membershipStatus", this.membershipStatus)
    // console.log("membershipStatus !== Expired", this.membershipStatus !== "Expired")
  }


  onSupportiveDocumentsSelected(event: any) {

    // type fileList
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    // to make each select replace the others
    this.selectedSupportedDocuments = [];
    this.previewUrls4 = [];

    // transfer from fileList to array
    Array.from(files).forEach((file: File) => {
      this.selectedSupportedDocuments.push(file);

      // transfer file to base64 to show in Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrls4.push(reader.result as string);
      };
      reader.readAsDataURL(file);
    });
  }



  onSubmit(): void {


    this.MembershipForm.markAllAsTouched();
    // console.log("Form Values:", this.MembershipForm.value);

    const hasImage = this.selectedNationalIdFrontPath ||
      this.selectedNationalIdBackPath ||
      this.selectedPassportImagePath ||
      this.selectedSupportedDocuments.length > 0 ||
      (this.membershipDataForUser && (
        this.membershipDataForUser.nationalIdFrontPath ||
        this.membershipDataForUser.nationalIdBackPath ||
        this.membershipDataForUser.passportImagePath ||
        this.membershipDataForUser.supportedDocuments
      ));

    if (!hasImage) {
      this.toastType = 'error';
      this.toastMessage = this.translate.instant('MEMBERSHIP.PLEASE_UPLOAD_AT_LEAST_ONE_IMAGE');
      this.showToast = true;
      setTimeout(() => this.showToast = false, 3000);
      return; // تمنع إرسال الفورم
    }

    if (this.MembershipForm.valid) {
      const formData = new FormData();

      // أضيفي كل قيم الفورم
      // Object.keys(this.MembershipForm.value).forEach(key => {
      //   let value = this.MembershipForm.get(key)?.value;

      //   if (value !== null && value !== undefined) {
      //     formData.append(key, value.toString());
      //   }
      // });
      const formValues = this.MembershipForm.getRawValue(); // includes disabled controls
      Object.keys(formValues).forEach(key => {
        let value = formValues[key];
        if (value !== null && value !== undefined) {
          formData.append(key, value.toString());
        }
      });





      // أضيفي الصورة لو فيه صورة مختارة
      if (this.selectedNationalIdFrontPath) {
        formData.append('NationalIdFront', this.selectedNationalIdFrontPath);
      }
      // else if (this.previewUrl1) {
      //   formData.append('NationalIdFrontUrl', this.previewUrl1.toString()); // ابعته كـ URL أو path
      // }

      if (this.selectedNationalIdBackPath) {
        formData.append('NationalIdBack', this.selectedNationalIdBackPath);
      }
      // else if (this.previewUrl2) {
      //   formData.append('NationalIdBack', this.previewUrl2.toString()); // ابعته كـ URL أو path
      // }

      if (this.selectedPassportImagePath) {
        formData.append('PassportImage', this.selectedPassportImagePath);
      }
      if (this.selectedSupportedDocuments.length > 0) {
        this.selectedSupportedDocuments.forEach(file => {
          formData.append('SupportedDocuments', file);
        });
      }

      // else if (this.previewUrl3) {
      //   formData.append('PassportImage', this.previewUrl3.toString()); // ابعته كـ URL أو path
      // }



      if (!this.isUserCreatedBefore && this.membershipStatus === "") {
        const sub = this.MembershipService.ApplyForMembership(formData).subscribe({
          next: (response: any) => {
            // console.log("API response:", response.succeeded);
            if (response.succeeded) {
              // console.log("succeeded");
              this.toastType = 'success';
              this.toastMessage = this.translate.instant('MEMBERSHIP.SUCESSFULLY_CREATED_PROFILE');
              this.showToast = true;
              this.cdr.detectChanges();
              setTimeout(() => this.showToast = false, 3000);
              // setTimeout(() => this.closeMembershipModal(), 4000);
              this.closeMembershipModal()
              this.getMembershipByUserId.emit();
            }
            else {
              this.toastType = 'error';
              this.toastMessage = response.errors[0];
              this.showToast = true;
              this.cdr.detectChanges();
              setTimeout(() => this.showToast = false, 3000);
            }
          },
          error: (err: any) => {
            // console.log("error");
            this.toastType = 'error';
            this.toastMessage = this.translate.instant('MEMBERSHIP.ERROR_THROUGH_CREATING_PROFILE');
            this.showToast = true;
            setTimeout(() => this.showToast = false, 3000);
          }
        });
        this.subs.add(sub);
      }
      else if (this.isExpired && this.membershipStatus === "Expired") {
        const sub = this.MembershipService.reapplyOnMembership(formData).subscribe({
          next: (response: any) => {
            // console.log("API response:", response.succeeded);
            if (response.succeeded) {
              // console.log("succeeded");
              this.toastType = 'success';
              this.toastMessage = this.translate.instant('MEMBERSHIP.SUCESSFULLY_REAPPLY_MEMBERSHIP');
              this.showToast = true;
              this.cdr.detectChanges();
              setTimeout(() => this.showToast = false, 3000);
              // setTimeout(() => this.closeMembershipModal(), 4000);
              this.closeMembershipModal()
              this.getMembershipByUserId.emit();
            }
            else {
              this.toastType = 'error';
              this.toastMessage = response.errors[0];
              this.showToast = true;
              this.cdr.detectChanges();
              setTimeout(() => this.showToast = false, 3000);
            }
          },
          error: (err: any) => {
            // console.log("error");
            this.toastType = 'error';
            this.toastMessage = this.translate.instant('MEMBERSHIP.ERROR_THROUGH_REAPPLYING_MEMBERSHIP');
            this.showToast = true;
            setTimeout(() => this.showToast = false, 3000);
          }
        });
        this.subs.add(sub);
      }
      else {
        formData.append('MembershipId', this.membershipId?.toString() || '');
        const sub = this.MembershipService.UpdateMembership(formData).subscribe({
          next: (response: any) => {
            // console.log("API response:", response.succeeded);
            if (response.succeeded) {
              // console.log("succeeded");
              this.toastType = 'success';
              this.toastMessage = this.translate.instant('MEMBERSHIP.SUCESSFULLY_UPDATED_PROFILE');
              this.showToast = true;
              setTimeout(() => this.showToast = false, 3000);
              this.getMembershipByUserId.emit();
            }
            else {
              this.toastType = 'error';
              this.toastMessage = response.errors[0];
              this.showToast = true;

              setTimeout(() => this.showToast = false, 3000);
            }
          },
          error: (err: any) => {
            // console.log("error");
            this.toastType = 'error';
            this.toastMessage = this.translate.instant('MEMBERSHIP.ERROR_THROUGTH_UPDATING_PROFILE');
            this.showToast = true;
            setTimeout(() => this.showToast = false, 3000);
          }
        });
        this.subs.add(sub);
      }
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    const field = event.target.name; // front | back | passport

    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      if (field === 'nationalIdFrontPath') {
        this.selectedNationalIdFrontPath = file;
        this.previewUrl1 = reader.result;
      }
      if (field === 'nationalIdBackPath') {
        this.selectedNationalIdBackPath = file;
        this.previewUrl2 = reader.result;
      }
      if (field === 'passportImagePath') {
        this.selectedPassportImagePath = file;
        this.previewUrl3 = reader.result;
      }
      // if (field === 'supportedDocument') {
      //   this.selectedSupportedDocument = file;
      //   this.previewUrl4 = reader.result;
      // }
    };

    reader.readAsDataURL(file);
  }


  closeMembershipModal() {
    this.showMembershipModal = false;

    // خزّن إنه قفل المودال
    localStorage.setItem('membershipModalClosed', 'true');

    // إزالة الباك دروب لو لسه موجود
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();
  }

  get f() {
    return this.MembershipForm.controls;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }

}
